<ng-container *ngIf="form">
    <app-basic-card>
        <app-basic-form [form]="form" [keys]="keys"></app-basic-form>
    </app-basic-card>
</ng-container>

<div class="mt-3 mb-3" *ngIf="beneficiariesList">
    <app-basic-card>
        <app-beneficiary-change [beneficiariesList]="beneficiariesList"
            [isReadOnly]="isReadOnly" [isSimor]="isSimor" [questionnaireForm]="questionnaireForm"
            [questionnaires]="questionnaires" [questionnairesArray]="questionnairesArray"
            [newLiquidationSubjects]="newLiquidationSubjects"
            (viewSubject)="viewSubject.emit($event)"
            (deleteSubject)="deleteSubject.emit($event)"
            (newLiquidationSubjectsChange)="newLiquidationSubjectsChange.emit($event)"
        ></app-beneficiary-change>
    </app-basic-card>
</div>
